import React from "react";
import color from "../../resource/color";
import Text from "../Text/Text";
import { Space } from "antd";
import { formatThaiNumber } from "../../utility/formatThaiNumber";

type MilestoneProgressProps = {
  progress: number;
  milestones: { value: number; icon: React.ReactNode; name: string; targetAmount: string }[];
  icon: any;
};

const MilestoneProgress: React.FC<MilestoneProgressProps> = ({ progress, milestones, icon }) => {
  const totalMilestones = milestones.length - 1;
  const progressPercent = progress / 100;

  return (
    <div
      style={{
        position: "relative",
        padding: "20px 0",
      }}
    >
      <div
        style={{
          position: "relative",
          height: "140px",
          width: "100%",
          maxWidth: "1000px",
          margin: "0 1",
        }}
      >
        <div
          style={{
            backgroundColor: "#e0e0e0",
            width: "90%",
            height: "9px",
            borderRadius: "6px",
            position: "absolute",
            top: "50%",
            left: "5%",
            transform: "translateY(-50%)",
          }}
        />
        <div
          style={{
            background: `linear-gradient(100deg, ${color.primary} 0%, ${color.softPrimary} 90%)`,
            width: `${progressPercent * 85}%`,
            height: "9px",
            borderRadius: "6px",
            position: "absolute",
            top: "50%",
            left: "5%",
            transform: "translateY(-50%)",
            transition: "width 0.3s ease",
          }}
        />

        {milestones.slice(1).map((m, index) => {
          const actualIndex = index + 1;
          const leftPercent = (actualIndex / totalMilestones) * 90 + 5;
          const isFirst = actualIndex === 1;

          return (
            <div
              key={actualIndex}
              style={{
                position: "absolute",
                left: `${leftPercent}%`,
                top: "44%",
                transform: "translateX(-50%)",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor: isFirst ? color.primary : "#bbb",
                  border: "2px solid white",
                  margin: "0 auto 6px auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "-66px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "max-content",
                }}
              >
                <Space wrap size={4} direction='vertical' style={{ alignItems: "center" }}>
                  <img
                    src={m.icon as string}
                    style={{
                      width: "clamp(50px, 10vw, 70px)",
                      height: "clamp(36px, 8vw, 56px)",
                      marginBottom: "18px",
                    }}
                  />
                  <Text fontFamily='Sarabun' fontSize={12} fontWeight={600}>
                    {m.name}
                  </Text>
                  {isFirst ? (
                    <div
                      style={{
                        backgroundColor: color.primary,
                        padding: "2px 6px",
                        borderRadius: "4px",
                      }}
                    >
                      <Text fontFamily='Sarabun' fontSize={12} fontWeight={600} color='white'>
                        {formatThaiNumber(Number(m.targetAmount))}
                      </Text>
                    </div>
                  ) : (
                    <Text fontFamily='Sarabun' fontSize={12} fontWeight={600}>
                      {formatThaiNumber(Number(m.targetAmount))}
                    </Text>
                  )}
                </Space>
              </div>
            </div>
          );
        })}

        <div
          style={{
            position: "absolute",
            left: `${progressPercent * 90 + 5}%`,
            top: "48px",
            transform: "translate(-50%, -40%)",
            transition: "left 0.3s ease",
          }}
        >
          <img src={icon} style={{ height: 22, width: 46 }} />
        </div>
      </div>
    </div>
  );
};

export default MilestoneProgress;
